//import {Link} from 'react-router-dom';
import React/*, {useState}*/ from 'react';
import {useracc, postApi} from '../utils/functions';
//import EventEmitter from '../utils/emmiter';
import {UserContext} from '../utils/usercontext';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Button from 'react-bootstrap/Button';

export default class Twitch extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {
			show: 0,
			link: '',
			code: '',
		};
  };

	
  
  async componentDidMount() {

		const value = this.context;
		const getUser = await useracc();
		value.setUser( getUser );
		//EventEmitter.emit('/client', {data: 'no value'});

		let url = window.location.href.split('?')[1];
		//console.log(url);

		const param = new URLSearchParams();
		if( url ) {
			let params = url.split('&');
			for( let i in params ) {
				//console.log(params[i]);
				params[i] = params[i].split('=');
			}

			
			for( let i in params ) {
				param.append( params[i][0], params[i][1] );
			}
			
			console.log(params);
		}
		const x = await postApi('/api/v2/admin/twitch', param);
		//console.log(x.data);
		if( x.status===200 ) {
			console.log(x.data);
			this.setState({show: x.data.show, link: x.data.link?x.data.link:'', code: x.data.code?x.data.code:''});
		}


		//console.log(params);
	}

	componentWillUnmount() {
	}

	async confirmChannel(channel) {
		console.log(channel);
		if( window.confirm('Are you sure you wish to update API keys for this channel?') ) {
			const param = new URLSearchParams();
			param.append('code', this.state.code);
			param.append('channel', channel);
			const x = await postApi('/api/v2/admin/twitch', param);
			console.log(x.data);
			if( x.status===200 ) {
				this.setState({show: 2});
			}
		}
	}
	

	render() {
		
		return (
			<Container>
				{this.state.show===1&&
					<>
						<Row>
							<Col>Enable Mix365 Twitch Api<br /><br /></Col>
						</Row>
						<Row>
							<Col>
								<Button size="sm"><a href={this.state.link} target="_blank" ref="noreferrer">Authorise Twitch</a></Button>
							</Col>
						</Row>
					</>
				}
				{this.state.show===2&&
					<>
						<Row>
							<Col>Please select channel?</Col>
						</Row>
						<Row>
							<Col>
								<ButtonGroup size="sm">
									<Button onClick={()=>this.confirmChannel('hyper')}>Hyper</Button>
									<Button onClick={()=>this.confirmChannel('evolution')}>Evolution</Button>
								</ButtonGroup>
							</Col>
						</Row>
					</>
				}

				
			</Container>
		);
	}
}
